// extracted by mini-css-extract-plugin
export default {"backdrop":"AddNewSlider_backdrop__aOpGi","z_index_100":"AddNewSlider_z_index_100__Z-2y2","modal_title":"AddNewSlider_modal_title__f0a3J","BlogIcon":"AddNewSlider_BlogIcon__SyaUe"};